export const ACCOUNT_ENABLED_ANNOTATION = 'microsoft.com/account-enabled';
